module.exports = __webpack_public_path__ + "static/OMER_EMIR_CAGO_HAVELSAN-ad9a3b0933f9358ae71c1dac6cf8c183.jpeg";